import { withProps } from 'recompose';
import cx from 'classnames';
import { noop } from 'lodash';
import segmentLabelMap from 'sharedParts/config/segmentLabelMap';
import getRenderedNumericIcons from '../../utils/getRenderedNumericIcons';

import styles from './withNumericRatingIcons.scss';

const getInlineStyle = (segementType) => {
  switch (segementType) {
    case segmentLabelMap.noSegment:
      return styles['no-segment'];
    case segmentLabelMap.itemList:
    case segmentLabelMap.labelListEnd:
    case segmentLabelMap.labelListEndMidpoint:
      return styles['with-segment'];
    default:
      return '';
  }
};

export default withProps(
  ({
    ratingItemClassName,
    itemListCount: length,
    block: { textColor, shape, size, startFromZero, personalLabelType: labelType, segment },
    styling: { selectionColor },
  }) => {
    const inlineStyle = getInlineStyle(segment);
    return {
      ratingClassName: styles[`${shape}Container`],
      sliderHandleIcon: null,
      ratingIconList: getRenderedNumericIcons({
        color: selectionColor,
        textColor,
        length,
        labelType,
        size,
        startFromZero,
        e2e: 'numeric-item',
        iconTextClassName: cx(
          styles.iconText,
          length <= 5 || segment === segmentLabelMap.itemList ? styles['original-width'] : '',
        ),
        empty: {
          className: cx(ratingItemClassName, styles[shape], styles[size], styles.emptyItem, inlineStyle),
          onClick: noop,
        },
        full: {
          className: cx(ratingItemClassName, styles[shape], styles[size], styles.fullItem, inlineStyle),
          onClick: noop,
        },
      }),
    };
  },
);
